import Subscription from "../assets/images/CreatorCash/Subscription.svg";
import Validation from "../assets/images/CreatorCash/Validation.svg";
import Earnings from "../assets/images/CreatorCash/Earnings.svg";
import GetPaidFaster from '../assets/images/CreatorCash/GetPaidFaster.png';
import SaveFaster from '../assets/images/CreatorCash/SaveTime.png';
import OptimizeContent from '../assets/images/CreatorCash/OptimizeContent.png';
import StartBuilding from '../assets/images/CreatorCash/StartBuilding.png';

export const creators = [GetPaidFaster, SaveFaster, OptimizeContent, StartBuilding];
export const howItWorksSteps = [Subscription, Validation, Earnings];